export function initSwiper() {
  if (typeof Swiper === 'undefined') return;

  const dir = document.documentElement.getAttribute('dir') || 'rtl';

  document.querySelectorAll('[data-swiper]').forEach(el => {
    const config = JSON.parse(el.getAttribute('data-swiper') || '{}');
    const container = el.querySelector('.swiper');
    if (!container) return;

    const prevBtn = el.querySelector('[data-swiper-prev]');
    const nextBtn = el.querySelector('[data-swiper-next]');

    new Swiper(container, {
      direction: 'horizontal',
      loop: config.loop ?? true,
      autoHeight: false,
      autoplay: config.autoplay ? { delay: config.autoplay, disableOnInteraction: false } : false,
      spaceBetween: config.gap ?? 20,
      slidesPerView: config.mobile ?? 1,
      breakpoints: {
        640: { slidesPerView: config.tablet ?? 2 },
        1024: { slidesPerView: config.desktop ?? 3 },
      },
      navigation: (prevBtn && nextBtn) ? { prevEl: prevBtn, nextEl: nextBtn } : false,
      pagination: config.pagination ? { el: el.querySelector('.swiper-pagination'), clickable: true } : false,
    });
  });
}
